import styled from 'styled-components';
const ChangePasswordStyled = styled.div`
  width: 360px;
  padding-bottom: 32px;
  .red {
    color: #d10000;
  }
  .line {
    .username {
      width: 100%;
    }
    .pwd {
      width: 100%;
    }
  }
  .button-group {
    display: flex;
    justify-content: flex-end;
    .cancel-button {
      margin-right: 16px;
    }
  }
`;
export default ChangePasswordStyled;
